export default __webpack_public_path__ + "static/media/linkedinicon.66cb9c64.svg";